import React from 'react'
import ReactDOM from 'react-dom'
import { Columns } from 'labguard-cdk'
import { id } from '../PageOptionsTarget'

const PageOptionsPortal = props =>
  document.getElementById(id) &&
  ReactDOM.createPortal(<Columns layout="auto" justify="end" align="center" {...props} />, document.getElementById(id))

export default PageOptionsPortal
